import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
	"https://dlnudixhuwzubxshcdhu.supabase.co",
	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRsbnVkaXhodXd6dWJ4c2hjZGh1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDQ3MTg5NzYsImV4cCI6MjAyMDI5NDk3Nn0.ZmTlojw80D9PDKDflYXfjn780g-s8gLVwF2XAx7mL9A"
);

export { supabase };
